import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTablet: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconTablet"><Path fillRule="evenodd" clipRule="evenodd" d="M17.7559 2.0127C19.0164 2.14082 20 3.20566 20 4.5V19.5C20 20.8807 18.8807 22 17.5 22H6.5C5.11929 22 4 20.8807 4 19.5V4.5C4 3.11929 5.11929 2 6.5 2H17.5L17.7559 2.0127ZM8.5 18C8.22386 18 8 18.2239 8 18.5C8 18.7761 8.22386 19 8.5 19H15.5C15.7761 19 16 18.7761 16 18.5C16 18.2239 15.7761 18 15.5 18H8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTablet;
